import { colors } from '../../colors';
var imageGallery = {
  primaryColor: colors.white,
  bgColor: colors.sandy,
  tileBgColor: colors.white,
  iconBgColor: colors.sandy
};
export default imageGallery;